import * as net from '~/lib/net';
import { ResetPasswordEmailRequest, ResetPasswordRequest } from "~/apps/shared/apis/schemas";
import { PasswordReset } from "~/apps/shared/apis/endpoints";
import { getToken } from "~/apps/shared/services/token";

export const sendResetEmail = async (req) => {
  const payload = ResetPasswordEmailRequest.save(req);
  return await net.apiPost(PasswordReset.sendResetEmail(), getToken(), payload);
}

export const validateResetCode = async (code) => {
  return await net.apiGet(PasswordReset.validateResetCode(code), getToken());
}

export const setNewPassword = async (code, req) => {
  const payload = ResetPasswordRequest.save(req);
  return await net.apiPost(PasswordReset.setNewPassword(code), getToken(), payload);
}
